import { render, staticRenderFns } from "./RapidAssessmentText.vue?vue&type=template&id=2b84d3bf&"
import script from "./RapidAssessmentText.vue?vue&type=script&lang=ts&"
export * from "./RapidAssessmentText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b84d3bf')) {
      api.createRecord('2b84d3bf', component.options)
    } else {
      api.reload('2b84d3bf', component.options)
    }
    module.hot.accept("./RapidAssessmentText.vue?vue&type=template&id=2b84d3bf&", function () {
      api.rerender('2b84d3bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rapid-assessment/RapidAssessmentText.vue"
export default component.exports